import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Damage() {
  return (
    <LegalLayout title="Damage Policy" updated="February 6, 2026">
      <p>
        We treat every load like it&rsquo;s our own — but occasionally accidents happen. This policy covers what we&rsquo;ll do if
        your items are damaged or lost while in our care.
      </p>
      <h2>1. Reporting</h2>
      <p>
        Notify us within <strong>48 hours of delivery</strong> at info@foldora.ca with your order ID and photos.
        We can&rsquo;t process damage claims filed after 48 hours.
      </p>
      <h2>2. Coverage</h2>
      <ul>
        <li>Damaged items: reimbursement up to <strong>10× the affected item&rsquo;s share of the invoice</strong>, capped at <strong>CAD $250 per order</strong>.</li>
        <li>Lost items: reimbursement based on documented value, capped at <strong>CAD $250 per order</strong>.</li>
      </ul>
      <h2>3. Exclusions</h2>
      <ul>
        <li>Damage from care labels not being followed when you selected against our recommendation.</li>
        <li>Pre-existing wear, colour fading, or shrinkage typical of the fabric.</li>
        <li>Items containing money, jewellery, electronics, or hazardous materials left in pockets.</li>
        <li>Non-washable materials (leather, suede, silk marked "Dry Clean Only" unless our Dry Clean add-on was requested).</li>
      </ul>
      <h2>4. Resolution timeline</h2>
      <p>We aim to resolve every damage claim within 5 business days of receiving the report and photos.</p>
      <h2>5. Higher-value declarations</h2>
      <p>
        If your load contains items valued above $250, please note it in the booking notes and email us before pickup so we
        can offer optional upgraded coverage.
      </p>
    </LegalLayout>
  );
}
